import { Box, IconButton, Stack, SvgIcon, Tooltip, Typography } from "@mui/material";
import { CSSProperties, FC, useCallback, useMemo } from "react";
import { getStyles } from "./styles";
import ClearIcon from '@mui/icons-material/Clear';

interface IProps {
    isDisabled?: boolean;
    type: string;
    file: any;
    handleToggleVideoFile: () => void;
    handleDeleteImage: (name: string) => void;
};

export const FileDocumentBack: FC<IProps> = ({ file, type, handleDeleteImage, handleToggleVideoFile, isDisabled }) => {
    const styles = useMemo(() => getStyles(), []);

    return (
        <Stack key={file.size + file.name} alignItems="center">
            <Box sx={styles.imageBox}>
                <Tooltip
                    title={type === 'Video' ? 'Показати відео' : ''}
                    arrow
                    followCursor
                    onClick={handleToggleVideoFile}
                >
                    <img
                        src={
                            type === 'File' ?
                                "/images/user/document.png"
                                : "/images/user/video.png"
                        }
                        alt="image"
                        width={65}
                        height={65}
                        style={styles.fileImage as CSSProperties}
                    />
                </Tooltip>
                {!isDisabled &&
                <IconButton
                    size="small"
                    sx={styles.fileToolTip}
                    onClick={() => handleDeleteImage(file.filename)}
                >
                    <SvgIcon sx={{ fontSize: '14px' }}>
                        <ClearIcon />
                    </SvgIcon>
                </IconButton>}
            </Box>
            <Tooltip title={file.filename}>
                <Typography variant="subtitle2">
                    {file.filename.length > 10
                        ? `${file.filename.slice(0, 10)}...`
                        : file.filename
                    }
                </Typography>
            </Tooltip>
        </Stack>
    )
};